// extracted by mini-css-extract-plugin
export default {"dropzone":"style_dropzone__-vp1p"};